var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import clsx from "clsx";
import React from "react";
import { filterAttributes } from "../utils";
import * as defaultStyles from "./Image.module.css";
export default function Image(_a) {
  var _b = _a,
    {
      WrapperComponent = null,
      src,
      srcSet,
      srcWebp,
      srcSetWebp,
      width,
      height,
      base64,
      aspectRatio,
      alt,
      caption,
      credit,
      linkTo,
      estimatedWidth = 320,
      imgProps: _c = {}
    } = _b,
    _d = _c,
    {
      className: imgClassName
    } = _d,
    imgRestProps = __objRest(_d, ["className"]),
    _e = _b,
    {
      linkProps: _f = {}
    } = _e,
    _g = _f,
    {
      className: linkClassName
    } = _g,
    linkRestProps = __objRest(_g, ["className"]),
    _h = _e,
    {
      className,
      styles = defaultStyles
    } = _h,
    restProps = __objRest(_h, ["WrapperComponent", "src", "srcSet", "srcWebp", "srcSetWebp", "width", "height", "base64", "aspectRatio", "alt", "caption", "credit", "linkTo", "estimatedWidth", "imgProps", "linkProps", "className", "styles"]);
  let attributes = filterAttributes(restProps);
  return /* @__PURE__ */React.createElement("img", __spreadValues({
    className: clsx(styles.component, className),
    src,
    alt: ""
  }, attributes));
}